import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function useLeadSources(tid) {
  const api = useApi();
  const [opts, setOpts] = useState([]);
  useEffect(() => { api.get(`/t/${tid}/crm/sources`).then(({ data }) => setOpts(data.options)).catch(() => setOpts([])); }, [api, tid]);
  return opts;
}

export default function LeadSourceSelect({ opts, value, onChange, disabled, testid }) {
  const known = !value || opts.some((o) => o.key === value);
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)} disabled={disabled}>
      <SelectTrigger className="h-9 text-sm" data-testid={testid}>{opts.length ? <SelectValue /> : <span className="text-slate-400">Caricamento…</span>}</SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Non indicata</SelectItem>
        {opts.map((o) => <SelectItem key={o.key} value={o.key} data-testid={`${testid}-opt-${o.key}`}>{o.label}</SelectItem>)}
        {!known && <SelectItem value={value}>{value}</SelectItem>}
      </SelectContent>
    </Select>
  );
}
